export default "__VITE_ASSET__V4mfBIQ0__"